import { Observable, ReplaySubject } from 'rxjs';
import { InjectionToken } from '@angular/core';
import { PushData } from './push-data';

export const PUSH_HANDLER = new InjectionToken('kgr.push-handler');

export interface PushHandler {
  supported$: Observable<boolean>;
  permission$: Observable<NotificationPermission>;
  permissionGranted$: Observable<boolean>;
  foregroundMessage$: ReplaySubject<PushData>;
  init(config: any): Observable<void>;

  /**
   * returns the push device token
   */
  register(): Observable<string>;
  requestPermission(): Observable<NotificationPermission>;
  unregister(): Observable<void>;
  clearApplicationIconBadge(): Observable<void>;
  getFirebaseProjectId(): string;
}
